<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :maskClosable="false" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-collapse v-model="activeKey">
        <a-collapse-panel key="1" :header="$t('商户信息')" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="name">
                <span slot="label"><a-tooltip>{{ $t('商户名称') }}<template slot="title">{{ $t('商户名称') }}</template></a-tooltip></span>
                <a-input v-model="form.name" :maxLength="128" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="aliasName">
                <span slot="label"><a-tooltip>{{ $t('商户别名') }}<template slot="title">{{ $t('商户别名') }}</template></a-tooltip></span>
                <a-input v-model="form.aliasName" :maxLength="128" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="mcc">
                <span slot="label"><a-tooltip>{{ $t('商户类别') }}<template slot="title">{{ $t('商户类别') }}</template></a-tooltip></span>
                <a-select v-model="form.mcc" :placeholder="$t('请输入')+'主营行业'" allowClear @change="onIndustryChange">
                  <a-select-option v-for="(item, index) in industryList" :value="item.id" :key="index">
                    {{ item.categoryName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="serviceList">
                <span slot="label"><a-tooltip>{{ $t('商户使用服务') }}<template slot="title">{{ $t('service') }}</template></a-tooltip></span>
                <a-select v-model="form.serviceList" mode="multiple" :placeholder="$t('请选择')" style="width: 100%">
                  <a-select-option v-for="(item, index) in customDict.AlipayServiceEnum" :key="index" :value="item.type">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="certNo">
                <span slot="label"><a-tooltip>{{ $t('商户证件编号') }}<template slot="title">{{ $t('商户证件编号') }}</template></a-tooltip></span>
                <a-input v-model="form.certNo" :maxLength="64" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="certName">
                <span slot="label"><a-tooltip>{{ $t('证照名称') }}<template slot="title">{{ $t('证照名称') }}</template></a-tooltip></span>
                <a-input v-model="form.certName" :maxLength="128" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="certImage">
                <span slot="label"><a-tooltip>{{ $t('商户证件图') }}<template slot="title">{{ $t('商户证件图') }}</template></a-tooltip></span>
                <oss-upload-single v-model="form.certImage" :max-size="5" prefix="merchant" type="img" />
              </a-form-model-item>
            </a-col>
<!--            <a-col :span="12">
              <a-form-model-item prop="certImageBack">
                <span slot="label"><a-tooltip>{{ $t('证件反面') }}<template slot="title">{{ $t('证件反面,证件反面图片。目前只有当商户类型是个人商户且使用当面付服务时才需填写') }}</template></a-tooltip></span>
                <oss-upload-single v-model="form.certImageBack" :max-size="5" prefix="merchant" type="img" />
              </a-form-model-item>
            </a-col>-->
          </a-row>
        </a-collapse-panel>

        <a-collapse-panel key="2" :header="$t('法人信息')" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="legalName">
                <span slot="label"><a-tooltip>{{ $t('法人名称') }}<template slot="title">{{ $t('法人名称') }}</template></a-tooltip></span>
                <a-input v-model="form.legalName" :maxLength="85" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="legalCertType">
                <span slot="label"><a-tooltip>{{ $t('法人证件类型') }}<template slot="title">{{ $t('法人证件类型') }}</template></a-tooltip></span>
                <a-select disabled :placeholder="$t('请选择')+'状态'" style="width: 100%" v-model="form.legalCertType" allowClear>
                  <a-select-option v-for="(item, index) in customDict.AlipayCertTypeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="legalCertNo">
                <span slot="label"><a-tooltip>{{ $t('法人身份证号') }}<template slot="title">{{ $t('legal_cert_no') }}</template></a-tooltip></span>
                <a-input v-model="form.legalCertNo" :maxLength="40" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="legalCertFrontImage">
                <span slot="label"><a-tooltip>{{ $t('法人身份证人像面') }}<template slot="title">{{ $t('legal_cert_front_image') }}</template></a-tooltip></span>
                <oss-upload-single v-model="form.legalCertFrontImage" style="width:100px;height:80px" :max-size="5" prefix="merchant" type="img" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="legalCertBackImage">
                <span slot="label"><a-tooltip>{{ $t('法人身份证国徽面') }}<template slot="title">{{ $t('legal_cert_back_image') }}</template></a-tooltip></span>
                <oss-upload-single v-model="form.legalCertBackImage" style="width:100px;height:80px" :max-size="5" prefix="merchant" type="img" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>

        <a-collapse-panel key="3" :header="$t('经营地址')" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="districtCode">
                <span slot="label"><a-tooltip>{{ $t('省市区') }}<template slot="title">{{ $t('province_code / city_code / district_code') }}</template></a-tooltip></span>
                <a-cascader
                  :options="areaList"
                  :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                  :placeholder="$t('请选择')"
                  style="width: 100%"
                  v-model="areaSelected"
                  allowClear
                  @change="onAreaChange"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="address">
                <span slot="label"><a-tooltip>{{ $t('详细地址') }}<template slot="title">{{ $t('address') }}</template></a-tooltip></span>
                <a-input v-model="form.address" :maxLength="256" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="longitude">
                <span slot="label"><a-tooltip>{{ $t('经度') }}<template slot="title">{{ $t('longitude') }}</template></a-tooltip></span>
                <a-input-number v-model="form.longitude" :precision="6" style="width: 100%" :placeholder="$t('选填')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="latitude">
                <span slot="label"><a-tooltip>{{ $t('纬度') }}<template slot="title">{{ $t('latitude') }}</template></a-tooltip></span>
                <a-input-number v-model="form.latitude" :precision="6" style="width: 100%" :placeholder="$t('选填')" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>

        <a-collapse-panel key="4" :header="$t('结算与银行')" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="defaultSettleType">
                <span slot="label"><a-tooltip>{{ $t('默认结算类型') }}<template slot="title">{{ $t('default_settle_type') }}</template></a-tooltip></span>
                <a-select v-model="form.defaultSettleType" :placeholder="$t('请选择')" style="width: 100%">
                  <a-select-option value="bankCard">{{ $t('结算到银行卡') }}</a-select-option>
                  <a-select-option value="alipayAccount">{{ $t('结算到支付宝账号') }}</a-select-option>
                  <a-select-option value="alipayWallet">{{ $t('结算到支付宝钱包') }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col v-if="form.defaultSettleType && form.defaultSettleType !== 'bankCard'" :span="12">
              <a-form-model-item prop="alipayLogonId">
                <span slot="label"><a-tooltip>{{ $t('结算支付宝账号') }}<template slot="title">{{ $t('alipay_logon_id') }}</template></a-tooltip></span>
                <a-input v-model="form.alipayLogonId" :maxLength="128" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <template v-if="form.defaultSettleType === 'bankCard'">
              <a-col :span="12">
                <a-form-model-item prop="usageType">
                  <span slot="label"><a-tooltip>{{ $t('账号使用类型') }}<template slot="title">{{ $t('usage_type：01 对公；02 对私') }}</template></a-tooltip></span>
                  <a-radio-group v-model="form.usageType" button-style="solid">
                    <a-radio-button v-for="(item, index) in customDict.AlipayUsageTypeEnum" :key="index" :value="item.type">{{ item.name }}</a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="accountType">
                  <span slot="label"><a-tooltip>{{ $t('卡类型') }}<template slot="title">{{ $t('account_type：DC 借记；CC 信用卡') }}</template></a-tooltip></span>
                  <a-radio-group v-model="form.accountType" button-style="solid">
                    <a-radio-button v-for="(item, index) in customDict.AlipayAccountTypeEnum" :key="'acct'+index" :value="item.type">{{ item.name }}</a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="accountHolderName">
                  <span slot="label"><a-tooltip>{{ $t('开户名') }}<template slot="title">{{ $t('account_holder_name') }}</template></a-tooltip></span>
                  <a-input v-model="form.accountHolderName" :maxLength="85" :placeholder="$t('请输入')" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="accountNo">
                  <span slot="label"><a-tooltip>{{ $t('银行卡号') }}<template slot="title">{{ $t('account_no') }}</template></a-tooltip></span>
                  <a-input v-model="form.accountNo" :maxLength="40" :placeholder="$t('请输入')" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="accountInstName">
                  <span slot="label"><a-tooltip>{{ $t('银行名称') }}<template slot="title">{{ $t('account_inst_name') }}</template></a-tooltip></span>
                  <a-auto-complete class="global-search"  v-model="form.accountInstName"  style="width: 100%" placeholder="请输入开户银行查询" option-label-prop="title"
                                   @select="handleBankChange"
                                   @search="handleBankSearch">
                    <template slot="dataSource">
                      <a-select-option v-for="item in bankList" :key="item.bankAlias" :title="item.bankAlias">
                        {{ item.bankAlias }}
                      </a-select-option>
                    </template>
                  </a-auto-complete>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="accountBranchName">
                  <span slot="label"><a-tooltip>{{ $t('开户支行') }}<template slot="title">{{ $t('account_branch_name') }}</template></a-tooltip></span>
                  <a-button type="default" @click="$refs.RadioBranchSelectForm.openBranch(form.accountInstName)" style="text-align: left; width: 100%">
                    <span style="color: dodgerblue">{{ getBranchName() }}</span>
                  </a-button>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="bankCode">
                  <span slot="label"><a-tooltip>{{ $t('银行编码') }}<template slot="title">{{ $t('bank_code') }}</template></a-tooltip></span>
                  <a-input v-model="form.bankCode" disabled />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="accountInstProvince">
                  <span slot="label"><a-tooltip>{{ $t('开户行所在地省') }}<template slot="title">{{ $t('account_inst_province') }}</template></a-tooltip></span>
                  <a-input v-model="form.accountInstProvince" :maxLength="64" :placeholder="$t('请输入')" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="accountInstCity">
                  <span slot="label"><a-tooltip>{{ $t('开户行所在地市') }}<template slot="title">{{ $t('account_inst_city') }}</template></a-tooltip></span>
                  <a-input v-model="form.accountInstCity" :maxLength="64" :placeholder="$t('请输入')" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="accountInstId">
                  <span slot="label"><a-tooltip>{{ $t('开户行简称缩写') }}<template slot="title">{{ $t('account_inst_id') }}</template></a-tooltip></span>
                  <a-input v-model="form.accountInstId" :maxLength="32" :placeholder="$t('选择支行后自动带出')" disabled />
                </a-form-model-item>
              </a-col>
            </template>
          </a-row>
        </a-collapse-panel>

        <a-collapse-panel key="5" :header="$t('联系人与门店照')" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="servicePhone">
                <span slot="label"><a-tooltip>{{ $t('客服电话') }}<template slot="title">{{ $t('service_phone') }}</template></a-tooltip></span>
                <a-input v-model="form.servicePhone" :maxLength="32" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contactName">
                <span slot="label"><a-tooltip>{{ $t('联系人名字') }}<template slot="title">{{ $t('contact_name') }}</template></a-tooltip></span>
                <a-input v-model="form.contactName" :maxLength="85" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contactMobile">
                <span slot="label"><a-tooltip>{{ $t('联系人手机号') }}<template slot="title">{{ $t('contact_mobile') }}</template></a-tooltip></span>
                <a-input v-model="form.contactMobile" :maxLength="20" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contactIdCardNo">
                <span slot="label"><a-tooltip>{{ $t('联系人身份证号') }}<template slot="title">{{ $t('contact_id_card_no') }}</template></a-tooltip></span>
                <a-input v-model="form.contactIdCardNo" :maxLength="20" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="inDoorImages">
                <span slot="label"><a-tooltip>{{ $t('内景照') }}<template slot="title">{{ $t('in_door_images') }}</template></a-tooltip></span>
                <oss-upload-single v-model="form.inDoorImages" :max-size="5" prefix="merchant" type="img" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="outDoorImages">
                <span slot="label"><a-tooltip>{{ $t('门头照') }}<template slot="title">{{ $t('out_door_images') }}</template></a-tooltip></span>
                <oss-upload-single v-model="form.outDoorImages" :max-size="5" prefix="merchant" type="img" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="licenseAuthLetterImage">
                <span slot="label"><a-tooltip>{{ $t('授权函') }}<template slot="title">{{ $t('license_auth_letter_image') }}</template></a-tooltip></span>
                <oss-upload-single v-model="form.licenseAuthLetterImage" :max-size="5" prefix="merchant" type="img" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item prop="qualifications" :label-col="{span: 2}" :wrapper-col="{span: 20}">
                <span slot="label"><a-tooltip>{{ $t('商户行业资质') }}<template slot="title">{{ $t('qualifications，可为 JSON 字符串') }}</template></a-tooltip></span>
                <a-textarea v-model="form.qualifications" :rows="2" :placeholder="$t('选填')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item prop="sites" :label-col="{span: 2}" :wrapper-col="{span: 20}">
                <span slot="label"><a-tooltip>{{ $t('商户站点信息') }}<template slot="title">{{ $t('sites') }}</template></a-tooltip></span>
                <a-textarea v-model="form.sites" :rows="2" :placeholder="$t('选填')" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>
      </a-collapse>

      <radio-branch-select-form ref="RadioBranchSelectForm" @branchSelect="indexBranchSelect"></radio-branch-select-form>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getExtraApplyAlipay, addExtraApplyAlipay, updateExtraApplyAlipay } from '@/api/merchant/extraApplyAlipay'
import { getApplyByMerchantId } from '@/api/merchant/merchantApply'
import { mapGetters } from 'vuex'
import { areaListTree } from '@/api/logistics'
import { listIndustry } from '@/api/merchant/industry'
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
import RadioBranchSelectForm from '@/views/merchant/branch/modules/RadioSelectForm'
import {listBank} from "@/api/merchant/bank";

export default {
  name: 'CreateForm',
  props: {
    merchantId: {
      type: String,
      required: true
    },
    /** 平台商家类型：1 企业等，用于默认证件类型与行业查询 */
    merchantType: {
      type: Number,
      required: true,
      default: 1
    }
  },
  components: {
    OssUploadSingle,
    RadioBranchSelectForm
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: this.$t('请填写真实信息') + '（ant.merchant.expand.indirect.zft.create）',
      activeKey: ['1', '2', '3', '4', '5'],
      areaList: [],
      areaSelected: [],
      industryList: [],
      bankList: [],
      industrySelected: [],
      formType: 1,
      open: false,
      form: this.emptyForm(),
      rules: {
        merchantType: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        name: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        aliasName: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        mcc: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        serviceList: [{ required: true, type: 'array', min: 1, message: this.$t('不能为空'), trigger: 'change' }],
        certImageBack: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        legalCertType: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        legalCertNo: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        legalCertFrontImage: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        legalCertBackImage: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        districtCode: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        address: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        defaultSettleType: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        contactName: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        contactMobile: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        contactIdCardNo: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getAreaTree()
    this.getIndustryList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    emptyForm() {
      return {
        id: null,
        merchantId: this.merchantId ? Number(this.merchantId) : null,
        merchantType: undefined,
        name: null,
        aliasName: null,
        mcc: null,
        serviceList: ['app'],
        certNo: null,
        certName: null,
        certType: undefined,
        certImage: null,
        certImageBack: null,
        legalName: null,
        legalCertType: '100',
        legalCertNo: null,
        legalCertFrontImage: null,
        legalCertBackImage: null,
        provinceCode: null,
        cityCode: null,
        districtCode: null,
        address: null,
        longitude: undefined,
        latitude: undefined,
        defaultSettleType: 'bankCard',
        accountHolderName: null,
        accountNo: null,
        accountInstProvince: null,
        accountInstCity: null,
        accountBranchName: null,
        usageType: '02',
        accountType: 'DC',
        accountInstName: null,
        accountInstId: null,
        bankCode: null,
        inDoorImages: null,
        outDoorImages: null,
        alipayLogonId: null,
        bindingAlipayLogonId: null,
        servicePhone: null,
        contactName: null,
        contactMobile: null,
        contactIdCardNo: null,
        qualifications: null,
        licenseAuthLetterImage: null,
        sites: null
      }
    },
    getAreaTree() {
      areaListTree().then(response => {
        this.areaList = response.data
      })
    },
    getIndustryList() {
      listIndustry({ merchantType: this.merchantType }).then(response => {
        this.industryList = response.data
      })
    },
    onAreaChange(value, selectedOptions) {
      if (!selectedOptions || selectedOptions.length < 3) {
        this.form.provinceCode = null
        this.form.cityCode = null
        this.form.districtCode = null
        return
      }
      this.form.provinceCode = Number(selectedOptions[0].areaId)
      this.form.cityCode = Number(selectedOptions[1].areaId)
      this.form.districtCode = Number(selectedOptions[2].areaId)
    },
    onIndustryChange(value, selectedOptions) {
      this.form.mcc = selectedOptions[0].mcc
    },

    //银行选择
    handleBankSearch(value) {
      if (value === undefined) {
        return;
      }
      if (value === '') {
        return;
      }
      listBank({"bankAlias": value}).then(response => {
        this.bankList = response.data
      })
    },
    handleBankChange(value) {
      console.log('搜索选中了银行信息:',value)
      this.form.accountInstName = value;
    },
    getBranchName() {
      if (this.form.accountBranchName) {
        return this.form.accountBranchName
      }
      return this.$t('请选择') + this.$t('开户支行')
    },
    indexBranchSelect(record) {
      if (!record) return
      this.form.accountInstName = record.bankName
      this.form.accountBranchName = record.name
      this.form.bankCode = record.code
      this.form.accountInstId = record.bankCode
      this.form.accountInstProvince = record.provinceName
      this.form.accountInstCity = record.cityName
    },
    onClose() {
      this.cancel()
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = this.emptyForm()
      this.areaSelected = []
      this.industrySelected = []
    },
    parseServiceList(row) {
      if (!row || !row.service) {
        return []
      }
      try {
        const arr = JSON.parse(row.service)
        return Array.isArray(arr) ? arr : []
      } catch (e) {
        return []
      }
    },
    handleAdd(merchantId, total) {
      this.reset()
      this.formType = 1
      this.form.merchantId = merchantId
      //	1, "企业",  2, "个人",4, "事业单位",
      if (this.merchantType ===1) {
        this.form.merchantType= "01"
        //营业执照
        this.form.certType = '201'
      } else if (this.merchantType ===2) {
        this.form.merchantType= "06"
        //身份证
        this.form.certType = '100'
      } else if (this.merchantType === 4) {
        this.form.merchantType = "02";
      }
      getApplyByMerchantId({ id: merchantId || this.merchantId }).then(response => {
        if (response.data) {
          const d = response.data
          this.form.name = d.merchantName
          this.form.aliasName = d.merchantName
          this.form.address = d.merchantAddress
          if (this.merchantType === 1) {
            this.form.certNo = d.businessLicenceNo
            this.form.certImage = d.businessLicenseImg
          }
          this.form.legalName = d.contactName
          this.form.legalCertNo = d.contactCardNo
          this.form.legalCertFrontImage = d.contactCardFace
          this.form.legalCertBackImage = d.contactCardNational
          this.form.contactName = d.contactName
          this.form.contactMobile = d.contactPhone
          this.form.contactIdCardNo = d.contactCardNo
          //省市区自动回填
          this.areaSelected = [d.merchantAreap, d.merchantAreac, d.merchantAreax]
          this.form.provinceCode = d.merchantAreap
          this.form.cityCode = d.merchantAreac
          this.form.districtCode = d.merchantAreax
          //经纬度
          this.form.longitude = d.merchantLongitude
          this.form.latitude = d.merchantLatitude
          this.form.servicePhone = d.servicePhone

          if (d.branchResult) {
            this.indexBranchSelect({
              name: d.branchResult.name,
              bankName: d.branchResult.bankAlias,
              code: d.branchResult.code,
              bankAlias: d.branchResult.bankAlias,
              provinceName: d.branchResult.provinceName,
              cityName: d.branchResult.cityName
            })
            this.form.accountNo = d.accountNo
            this.form.accountHolderName = d.accountName
          }
        }
      });
      this.open = true
    },
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getExtraApplyAlipay({ id }).then(response => {
        const d = response.data
        const { service, ...rest } = d
        this.form = { ...this.emptyForm(), ...rest, serviceList: this.parseServiceList(d) }
        if (d.provinceCode && d.cityCode && d.districtCode) {
          this.areaSelected = [d.provinceCode, d.cityCode, d.districtCode]
        }
        this.open = true
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        const payload = this.form
        if (this.formType === 2 && this.form.id) {
          payload.id = this.form.id
          updateExtraApplyAlipay(payload)
            .then(response => {
              if (response.code === '20001') {
                this.$message.success(this.$t('修改成功'), 3)
                this.open = false
                this.$emit('ok')
              }
            })
            .finally(() => {
              this.submitLoading = false
            })
        } else {
          addExtraApplyAlipay(payload)
            .then(response => {
              if (response.code === '20001') {
                this.$message.success(this.$t('新增成功'), 3)
                this.open = false
                this.$emit('ok')
              }
            })
            .finally(() => {
              this.submitLoading = false
            })
        }
      })
    }
  }
}
</script>
<style lang="less">
.goods-collapse > .ant-collapse-header {
  color: #0e75d3 !important;
  background: #e8eef9;
}
</style>
